const OFFERS_CLICKOUT_ENDPOINT = import.meta.env
  .VITE_OFFERS_CLICKOUT_SERVICE_URL;

export default function clickoutServiceUrlMap({
  offers,
  gtmId,
  deviceType,
  recommendedMarketId,
  apiKey
}) {
  return offers.map((item, index) => {
    const clickoutData = new URLSearchParams(
      Object.entries({
        apiKey,
        deviceType,
        gtmId,
        offerId: item.id,
        offerPosition: index,
        pageUrl: window.location.pathname,
        recommendedMarketId
      }).filter(entry => entry[1] != null)
    );

    return {
      ...item,
      clickoutUrl: {
        url: `${OFFERS_CLICKOUT_ENDPOINT}?${clickoutData}`,
        original: item.clickoutUrl.url
      }
    };
  });
}
